import { Money } from '../../../types';
import { handleAction } from 'redux-actions';
import { SET_PRICE, SetPriceAction } from './action';
import { Currency } from '../../../enums';

export interface PriceBreakdownState {
	totalPrice: Money;
	servicePrice: Money;
	upsalePrice: Money;
}

export const initialPriceBreakdownState: PriceBreakdownState = {
	totalPrice: {
		amount: 0,
		currency: Currency.USD
	},
	servicePrice: {
		amount: 0,
		currency: Currency.USD
	},
	upsalePrice: {
		amount: 0,
		currency: Currency.USD
	}
};

export const priceBreakdownReducer = handleAction(
	SET_PRICE,
	(state: PriceBreakdownState, action: SetPriceAction) => {
		if (action.payload) {
			return { ...state, ...action.payload };
		}

		return state;
	},
	initialPriceBreakdownState
);
